import {ScriptHTMLAttributes} from 'react'

import {Props} from './MetrikaScript'
import {GoogleAnalytics, Metrika, YandexMetrika} from './types'

// простая очередь для метрики
// если скрипт метрики грузится долго, но приложение уже начало собирать метрику
// то собранные данные терять не хочется, поэтому копим их в массив
// и после инициализации метрики просто вызовем все накопленные события
function createQueue<T>() {
  type Method = keyof T
  type Arguments = any[]
  type Queue = [Method, Arguments]

  const queue: Queue[] = []

  function create<K extends Method>(method: K) {
    function add2queue(...args: Arguments) {
      queue.push([method, args])
    }

    return add2queue
  }

  function emit(counter: T) {
    // @ts-ignore не охота заморачиваться типизацией
    queue.forEach(([method, args]) => counter[method].apply(null, args))
  }

  return {
    create,
    emit,
  }
}

const yandexQueue = createQueue<YandexMetrika>()
const googleQueue = createQueue<GoogleAnalytics>()

export const emitYandexQueue = yandexQueue.emit
export const emitGoogleQueue = googleQueue.emit

export const emptyMetrika: Metrika = {
  reachGoal: yandexQueue.create('reachGoal'),
  setVisitParams: yandexQueue.create('setVisitParams'),
  trackVirtualPage: yandexQueue.create('trackVirtualPage'),
  trackGA: googleQueue.create('trackGA'),
}

export const getScript = (id: Props['metrikaID']) =>
  `(function (d, w, c) { (w[c] = w[c] || []).push(function() { try { w.yaCounter${id} = new Ya.Metrika2({ id:${id}, clickmap:true, trackLinks:true, accurateTrackBounce:true, webvisor:true }); } catch(e) { } }); var n = d.getElementsByTagName("script")[0], s = d.createElement("script"), f = function () { n.parentNode.insertBefore(s, n); }; s.type = "text/javascript"; s.async = true; s.src = "https://mc.yandex.ru/metrika/tag.js"; if (w.opera == "[object Opera]") { d.addEventListener("DOMContentLoaded", f, false); } else { f(); } })(document, window, "yandex_metrika_callbacks2")`

export const attachScript = (src: string, attrs: ScriptHTMLAttributes<HTMLScriptElement> = {async: true}) => {
  return new Promise((resolve, reject) => {
    if (typeof document === 'undefined') {
      return resolve(null)
    }

    const node = document.createElement('script')

    node.type = 'text/javascript'
    node.src = src

    Object.keys(attrs).forEach(key => {
      node[key] = attrs[key]
    })

    node.addEventListener('error', () => {
      reject(`Can't load script with url - ${src}`)
    })
    node.addEventListener('load', () => {
      resolve(node)
    })

    document.body.appendChild(node)
  })
}
